module.exports = __webpack_public_path__ + "img/ivy-logo-1.340af960.png";